<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<header class="page-header client-meetings__header">
  <div>
    <h2>Calls com a Legatus</h2>
    <p class="client-meetings__subtitle">
      As reuniões gravadas que a Legatus liberou para a sua empresa, com o vídeo, a transcrição e o
      resumo.
    </p>
  </div>
  <app-search
    [value]="search()"
    [realTime]="true"
    [placeholder]="'Buscar pelo título'"
    (sendSearch)="handleSearch($event)" />
</header>

@if (error()) {
  <div class="client-meetings__error" role="alert">
    <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
    <span>{{ error() }}</span>
    <app-button
      [label]="'Tentar de novo'"
      [theme]="'white'"
      [size]="'small'"
      [type]="'button'"
      (sendButtonClick)="loadPage()" />
  </div>
}

<section class="client-meetings__list" [class.client-meetings__list--loading]="loading()">
  @if (loading() && !meetings().length) {
    <app-cog-loading-spinner />
  }
  @for (meeting of meetings(); track meeting.id) {
    <button type="button" class="client-meetings__row" (click)="open(meeting)">
      <span class="client-meetings__icon" aria-hidden="true"><i class="pi pi-video"></i></span>
      <span class="client-meetings__main">
        <strong class="client-meetings__title">{{ title(meeting) }}</strong>
        @if (meeting.shortDescription) {
          <span class="client-meetings__description">{{ meeting.shortDescription }}</span>
        }
        <span class="client-meetings__meta">
          {{ meeting.scheduledStartAt | vaultDateTime }}
          @if (meeting.durationSeconds != null) {
            · {{ duration(meeting.durationSeconds) }}
          }
        </span>
      </span>
      <i class="pi pi-chevron-right client-meetings__chevron" aria-hidden="true"></i>
    </button>
  } @empty {
    @if (!loading() && !error()) {
      <div class="client-meetings__empty">
        <i class="pi pi-video" aria-hidden="true"></i>
        <strong>Nenhuma call liberada ainda.</strong>
        <span>
          Quando a Legatus liberar uma reunião gravada com a sua empresa, ela aparece aqui.
        </span>
      </div>
    }
  }

  @if (total() > rows()) {
    <footer class="client-meetings__footer">
      <p-paginator
        [first]="firstRow()"
        [rows]="rows()"
        [totalRecords]="total()"
        [rowsPerPageOptions]="pageSizeOptions"
        (onPageChange)="handlePagination($event)" />
    </footer>
  }
</section>
